window.NAK = window.NAK || {};

NAK.initHero = function(root){
  var panels = root.querySelectorAll('.nak-hero-panel');
  var buttons = root.querySelectorAll('.nak-switch button');
  var playBtn = root.querySelector('.nak-play');
  var ctaBtn = root.querySelector('.nak-hero-cta');
  var order = Array.prototype.map.call(buttons, function(b){ return b.dataset.key; });
  var current = order[0];
  var timer = null;
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show(key){
    current = key;
    panels.forEach(function(p){ p.classList.toggle('active', p.dataset.key === key); });
    buttons.forEach(function(b){ b.classList.toggle('active', b.dataset.key === key); });
    if(ctaBtn){
      var activePanel = root.querySelector('.nak-hero-panel[data-key="' + key + '"]');
      if(activePanel){
        ctaBtn.href = activePanel.dataset.url;
        ctaBtn.textContent = 'K\u00f6p ' + activePanel.dataset.name;
      }
    }
  }
  buttons.forEach(function(b){
    b.addEventListener('click', function(){ stop(); show(b.dataset.key); });
  });
  function start(){
    if(!playBtn || timer) return;
    playBtn.textContent = '\u275A\u275A';
    timer = setInterval(function(){
      var idx = order.indexOf(current);
      show(order[(idx + 1) % order.length]);
    }, 2400);
  }
  function stop(){
    if(!playBtn) return;
    playBtn.textContent = '\u25B6';
    clearInterval(timer);
    timer = null;
  }
  if(playBtn){
    playBtn.addEventListener('click', function(){ if(timer) stop(); else start(); });
  }
  if(order.length) show(order[0]);

  /* Auto-play the hero slideshow as soon as the page loads, unless the
     visitor has requested reduced motion. */
  if(order.length > 1 && !prefersReducedMotion){
    start();
  }
};

NAK.initQuiz = function(root){
  var box = root.querySelector('.nak-quiz-box');
  if(!box) return;
  var dataEl = root.querySelector('script[type="application/json"]');
  var data = JSON.parse(dataEl.textContent);
  var questions = data.questions;
  var products = data.products;
  var step = 0;
  var scores = {};
  products.forEach(function(p){ scores[p.key] = 0; });

  function render(){
    if(step >= questions.length){
      var winnerKey = Object.keys(scores).reduce(function(a,b){ return scores[a] >= scores[b] ? a : b; });
      var p = products.filter(function(x){ return x.key === winnerKey; })[0];
      box.innerHTML =
        '<div class="nak-result nak-mono" style="text-transform:none;">' +
        '<div class="nak-q-num nak-mono">Resultat</div>' +
        '<h3 class="nak-display">' + p.name + '</h3>' +
        '<div class="pers">' + p.personality + ' \u00b7 ' + p.habitat + '</div>' +
        '<p>' + p.bio + '</p>' +
        '<a class="nak-btn-line" href="' + p.url + '">Visa ' + p.name + '</a>' +
        '<button class="nak-restart">G\u00f6r om quizet</button>' +
        '</div>';
      box.querySelector('.nak-restart').addEventListener('click', function(){
        step = 0; products.forEach(function(p){ scores[p.key] = 0; }); render();
      });
      return;
    }
    var q = questions[step];
    var progress = questions.map(function(_, i){ return '<span class="' + (i < step ? 'done' : '') + '"></span>'; }).join('');
    var opts = q.a.map(function(opt){ return '<button data-key="' + opt[1] + '">' + opt[0] + '</button>'; }).join('');
    box.innerHTML =
      '<div class="nak-progress">' + progress + '</div>' +
      '<div class="nak-q">' +
      '<div class="nak-q-num nak-mono">Fr\u00e5ga ' + (step + 1) + ' / ' + questions.length + '</div>' +
      '<h3>' + q.q + '</h3>' +
      '<div class="nak-opts">' + opts + '</div>' +
      '</div>';
    Array.prototype.forEach.call(box.querySelectorAll('.nak-opts button'), function(btn){
      btn.addEventListener('click', function(){
        scores[btn.dataset.key]++;
        step++;
        render();
      });
    });
  }
  render();
};

NAK.initGrid = function(root){
  var toggle = root.querySelectorAll('.nak-view-toggle button');
  var views = root.querySelectorAll('.nak-view');
  toggle.forEach(function(btn){
    btn.addEventListener('click', function(){
      toggle.forEach(function(b){ b.classList.toggle('active', b === btn); });
      views.forEach(function(v){ v.classList.toggle('active', v.dataset.view === btn.dataset.view); });
    });
  });
};
